import { useTranslation } from 'react-i18next';

export default function Process() {
  const { t } = useTranslation();

  const steps = [
    {
      number: '01',
      title: t('process.step1Title'),
      description: t('process.step1Desc'),
      icon: 'ri-alert-fill',
      image: 'https://public.readdy.ai/ai/img_res/9a1e4d8b0fb59e57520bf24d03ae8403.jpg'
    },
    {
      number: '02',
      title: t('process.step2Title'),
      description: t('process.step2Desc'),
      icon: 'ri-search-eye-fill',
      image: 'https://readdy.ai/api/search-image?query=Expert%20technician%20examining%20damaged%20suitcase%20with%20magnifying%20tool%20and%20digital%20tablet%2C%20detailed%20close-up%20of%20luggage%20inspection%2C%20professional%20repair%20workshop%20with%20organized%20tools%2C%20turquoise%20lighting%20accents%2C%20precision%20craftsmanship%20atmosphere&width=400&height=300&seq=process-diagnostic-001&orientation=landscape'
    },
    {
      number: '03',
      title: t('process.step3Title'),
      description: t('process.step3Desc'),
      icon: 'ri-tools-fill',
      image: 'https://readdy.ai/api/search-image?query=Skilled%20hands%20repairing%20luxury%20suitcase%20with%20professional%20tools%2C%20close-up%20of%20wheel%20replacement%20and%20handle%20fixing%2C%20organized%20workbench%20with%20spare%20parts%2C%20warm%20orange%20lighting%2C%20high-quality%20craftsmanship%20detail%20shot&width=400&height=300&seq=process-repair-001&orientation=landscape'
    },
    {
      number: '04',
      title: t('process.step4Title'),
      description: t('process.step4Desc'),
      icon: 'ri-checkbox-circle-fill',
      image: 'https://readdy.ai/api/search-image?query=Happy%20passenger%20receiving%20perfectly%20repaired%20premium%20luggage%20from%20delivery%20person%2C%20modern%20hotel%20lobby%20or%20airport%20setting%2C%20satisfied%20customer%20smiling%2C%20professional%20handover%20scene%2C%20purple%20and%20coral%20color%20scheme&width=400&height=300&seq=process-delivery-001&orientation=landscape'
    },
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-[#1a1a2e] via-[#16213e] to-[#0f3460] relative overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#FF6B6B]/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#4ECDC4]/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <span className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full text-[#4ECDC4] text-sm font-semibold mb-4">
            <i className="ri-route-fill"></i>
            {t('process.badge')}
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
            {t('process.title')}
            <br />
            <span className="bg-gradient-to-r from-[#FF6B6B] to-[#4ECDC4] bg-clip-text text-transparent">
              {t('process.titleHighlight')}
            </span>
          </h2>
          <p className="text-xl text-white/70 max-w-2xl mx-auto">
            {t('process.subtitle')}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {steps.map((step, index) => (
            <div 
              key={index}
              className="group relative bg-white/5 backdrop-blur-sm rounded-3xl p-8 border border-white/10 hover:bg-white/10 transition-all duration-300"
            >
              {/* Step Image */}
              <div className="relative h-48 rounded-2xl overflow-hidden mb-6">
                <img 
                  src={step.image}
                  alt={step.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a2e]/80 via-transparent to-transparent"></div>
                
                {/* Step Number Badge */}
                <div className="absolute top-4 left-4 w-16 h-16 bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] rounded-2xl flex items-center justify-center shadow-xl">
                  <span className="text-white text-xl font-bold" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    {step.number}
                  </span>
                </div>
              </div>

              {/* Content */}
              <div className="flex items-start gap-4">
                <div className="w-14 h-14 bg-gradient-to-br from-[#4ECDC4] to-[#44A08D] rounded-2xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                  <i className={`${step.icon} text-white text-2xl`}></i>
                </div>
                
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-white mb-3 group-hover:text-[#4ECDC4] transition-colors" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    {step.title}
                  </h3>
                  <p className="text-white/70 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>

              {/* Connector Line (except last item) */}
              {index < steps.length - 1 && index % 2 === 0 && (
                <div className="hidden md:block absolute top-1/2 -right-4 w-8 h-0.5 bg-gradient-to-r from-[#4ECDC4] to-transparent"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
